<div class="page-container" [testId]="'inbound-reason-page'">
  <div class="page-topbar">
    <div class="page-header">
      <div class="page-heading">
        <h1 class="page-title">{{ 'servicenumber.inbound-reason.title' | i18n }}</h1>
        <p class="page-subtitle">{{ 'servicenumber.inbound-reason.subtitle' | i18n }}</p>
      </div>
      <div class="page-actions">
        <button nz-button nzType="primary" class="create-button" (click)="createReason()" [testId]="'inbound-reason-create-btn'">
          <i nz-icon nzType="plus"></i> {{ 'servicenumber.inbound-reason.button.add' | i18n }}
        </button>
      </div>
    </div>

    <div class="topbar-search" [testId]="'inbound-reason-topbar-search'">
      <div class="topbar-search-row has-controls">
        <button
          nz-button
          nzType="default"
          type="button"
          class="search-toggle"
          [class.is-active]="mobileSearchExpanded || !!trimmedSearchKeywords"
          (click)="toggleMobileSearch()"
          [testId]="'inbound-reason-mobile-search-toggle'"
        >
          <i nz-icon [nzType]="mobileSearchExpanded ? 'close' : 'search'"></i>
        </button>

        <nz-input-group
          [nzPrefix]="prefixIconSearch"
          class="search-input"
          [class.mobile-expanded]="mobileSearchExpanded || !!trimmedSearchKeywords"
        >
          <input
            #searchInputElement
            type="text"
            nz-input
            [placeholder]="'servicenumber.inbound-reason.search.placeholder' | i18n"
            [(ngModel)]="searchKeywords"
            (keyup.enter)="search()"
            [testId]="'inbound-reason-search-input'"
          />
        </nz-input-group>

        <div class="toolbar-controls" [testId]="'inbound-reason-header-filters'">
          <nz-select
            [ngModel]="typeFilter"
            (ngModelChange)="onFilterChange('type', $event)"
            nzAllowClear
            [nzPlaceHolder]="'servicenumber.inbound-reason.filter.type.all' | i18n"
            [nzDropdownClassName]="'inbound-reason-type-filter-dropdown'"
            class="filter-dropdown type-filter-dropdown"
            [testId]="'inbound-reason-type-select'"
          >
            <nz-option *ngFor="let opt of typeOptions" [nzLabel]="getCompactTypeOptionLabel(opt.value)" [nzValue]="opt.value" />
          </nz-select>

          <nz-select
            [ngModel]="statusFilter"
            (ngModelChange)="onFilterChange('status', $event)"
            nzAllowClear
            [nzPlaceHolder]="'servicenumber.inbound-reason.filter.status.all' | i18n"
            class="filter-dropdown status-filter-dropdown"
            [testId]="'inbound-reason-status-select'"
          >
            <nz-option *ngFor="let opt of statusOptions" [nzLabel]="opt.labelI18nKey | i18n" [nzValue]="opt.value" />
          </nz-select>
        </div>
      </div>

      <ng-template #prefixIconSearch>
        <i nz-icon nzType="search" style="color: #86909c"></i>
      </ng-template>
    </div>
  </div>

  <div class="page-scroll" #pageScroll>
    <div class="result-meta" [testId]="'inbound-reason-result-meta'">
      <div class="result-count" [testId]="'inbound-reason-result-count'">
        {{ 'common.total-records' | i18n: { total: total } }}
      </div>
      <button
        *ngIf="hasActiveFilters()"
        nz-button
        nzType="link"
        type="button"
        class="clear-filters-inline"
        (click)="clearAllFilters()"
        [testId]="'inbound-reason-clear-filters-btn'"
      >
        {{ 'servicenumber.clear-filter' | i18n }}
      </button>
    </div>

    <div class="content-section">
      <div class="table-section" [testId]="'inbound-reason-table-section'">
        <nz-spin [nzSpinning]="loading" [nzTip]="'common.loading' | i18n">
          <nz-table
            #basicTable
            class="table-container"
            nzSize="middle"
            [nzData]="listOfData"
            [nzFrontPagination]="false"
            [nzShowPagination]="false"
            [nzScroll]="{ y: '100%' }"
            [nzTableLayout]="'auto'"
            [testId]="'inbound-reason-table'"
          >
            <thead>
              <tr>
                <th nzWidth="64px">{{ 'servicenumber.inbound-reason.table.type' | i18n }}</th>
                <th>{{ 'servicenumber.inbound-reason.table.name' | i18n }}</th>
                <th nzWidth="120px">{{ 'servicenumber.inbound-reason.table.inbound-count' | i18n }}</th>
                <th nzWidth="120px">{{ 'common.status' | i18n }}</th>
                <th nzWidth="120px">{{ 'servicenumber.inbound-reason.table.validity' | i18n }}</th>
                <th nzWidth="160px">{{ 'common.actions' | i18n }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of basicTable.data">
                <td>
                  <div class="icon-cell">
                    <span class="type-emoji">{{ getIconForType(item?.type) }}</span>
                  </div>
                </td>

                <td>
                  <div class="source-info">
                    <div class="source-title-row">
                      <span
                        class="source-title source-title-link"
                        (click)="openDetail(item, $event)"
                        [testId]="'inbound-reason-title-' + item?.id"
                        >{{ item?.title }}</span
                      >
                      <nz-tag
                        *ngIf="item?.regexEnabled && item?.regexRules?.length"
                        nzColor="blue"
                        class="regex-badge-tag"
                        nz-tooltip
                        [nzTooltipTitle]="getRegexTooltip(item)"
                        [testId]="'inbound-reason-regex-tag-' + item?.id"
                      >
                        <i nz-icon nzType="code"></i>
                        {{ 'servicenumber.inbound-reason.tag.regex-active' | i18n }} ({{ item?.regexRules?.length }})
                      </nz-tag>
                    </div>
                    <span class="source-desc">{{
                      item?.description ? item.description : ('servicenumber.inbound-reason.empty.description' | i18n)
                    }}</span>
                  </div>
                </td>

                <td>
                  <span style="font-family: 'Roboto', sans-serif">{{ getInboundCountText(item) }}</span>
                </td>

                <td>
                  <span class="status-pill" [ngClass]="getStatusPillClass(item)">
                    {{ getStatusI18nKey(item) | i18n }}
                  </span>
                </td>

                <td>
                  <span [style.color]="getValidityColor(item)">{{ getValidityLabel(item) }}</span>
                </td>

                <td class="table-actions-cell">
                  <div class="table-actions">
                    <i
                      nz-icon
                      nzType="eye"
                      nzTheme="outline"
                      nz-tooltip
                      [nzTooltipTitle]="'common.detail' | i18n"
                      (click)="openDetail(item, $event)"
                      [testId]="'inbound-reason-detail'"
                    ></i>
                    <i
                      *ngIf="isExpired(item)"
                      nz-icon
                      nzType="exclamation-circle"
                      nz-tooltip
                      [nzTooltipTitle]="'servicenumber.inbound-reason.action.expired-edit' | i18n"
                      class="expired-action"
                      (click)="editReason(item); $event.stopPropagation()"
                      [testId]="'inbound-reason-expired-edit'"
                    ></i>
                    <i
                      *ngIf="!isExpired(item) && normalizeStatus(item?.status) !== 'Enable'"
                      nz-icon
                      nzType="caret-right"
                      nzTheme="outline"
                      nz-tooltip
                      [nzTooltipTitle]="'servicenumber.inbound-reason.action.enable' | i18n"
                      class="status-toggle-enable"
                      (click)="toggleStatus(item); $event.stopPropagation()"
                      [testId]="'inbound-reason-toggle'"
                    ></i>
                    <i
                      *ngIf="!isExpired(item) && normalizeStatus(item?.status) === 'Enable'"
                      nz-icon
                      nzType="pause"
                      nzTheme="outline"
                      nz-tooltip
                      [nzTooltipTitle]="'servicenumber.inbound-reason.action.disable' | i18n"
                      class="status-toggle-disable"
                      (click)="toggleStatus(item); $event.stopPropagation()"
                      [testId]="'inbound-reason-toggle'"
                    ></i>
                    <i
                      nz-icon
                      nzType="link"
                      nz-tooltip
                      [nzTooltipTitle]="'servicenumber.inbound-reason.action.copy-link' | i18n"
                      (click)="viewReason(item); $event.stopPropagation()"
                      [testId]="'inbound-reason-link'"
                    ></i>
                    <i
                      nz-icon
                      nzType="edit"
                      nz-tooltip
                      [nzTooltipTitle]="'common.edit' | i18n"
                      (click)="editReason(item); $event.stopPropagation()"
                      [testId]="'inbound-reason-edit'"
                    ></i>
                    <i
                      nz-icon
                      nzType="delete"
                      nz-tooltip
                      [nzTooltipTitle]="'common.delete' | i18n"
                      style="color: #ff4d4f"
                      (click)="deleteReason(item); $event.stopPropagation()"
                      [testId]="'inbound-reason-delete'"
                    ></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </nz-spin>
      </div>

      <div class="mobile-card-section" [testId]="'inbound-reason-mobile-section'">
        <nz-spin [nzSpinning]="loading" [nzTip]="'common.loading' | i18n">
          <ng-container *ngIf="listOfData.length; else mobileEmpty">
            <div class="mobile-card-list">
              <div class="reason-card" *ngFor="let item of listOfData" [testId]="'inbound-reason-mobile-card-' + item.id">
                <div class="reason-card-header">
                  <div class="reason-card-title-wrap">
                    <div class="icon-cell">
                      <span class="type-emoji">{{ getIconForType(item?.type) }}</span>
                    </div>
                    <div class="source-info">
                      <div class="source-title-row">
                        <span
                          class="source-title source-title-link"
                          (click)="openDetail(item, $event)"
                          [testId]="'inbound-reason-mobile-title-' + item?.id"
                          >{{ item?.title }}</span
                        >
                        <nz-tag
                          *ngIf="item?.regexEnabled && item?.regexRules?.length"
                          nzColor="blue"
                          class="regex-badge-tag"
                          nz-tooltip
                          [nzTooltipTitle]="getRegexTooltip(item)"
                          [testId]="'inbound-reason-mobile-regex-tag-' + item?.id"
                        >
                          <i nz-icon nzType="code"></i>
                          {{ 'servicenumber.inbound-reason.tag.regex-active' | i18n }} ({{ item?.regexRules?.length }})
                        </nz-tag>
                      </div>
                      <span class="source-desc">{{
                        item?.description ? item.description : ('servicenumber.inbound-reason.empty.description' | i18n)
                      }}</span>
                    </div>
                  </div>
                  <span class="status-pill" [ngClass]="getStatusPillClass(item)">
                    {{ getStatusI18nKey(item) | i18n }}
                  </span>
                </div>

                <div class="reason-card-detail-rows">
                  <div class="detail-row">
                    <span class="detail-label">{{ 'servicenumber.inbound-reason.table.inbound-count' | i18n }}：</span>
                    <span class="detail-value">{{ getInboundCountText(item) }}</span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-label">{{ 'servicenumber.inbound-reason.table.validity' | i18n }}：</span>
                    <span class="detail-value" [style.color]="getValidityColor(item)">{{ getValidityLabel(item) }}</span>
                  </div>
                </div>

                <div class="reason-card-actions">
                  <button
                    nz-button
                    nzType="default"
                    type="button"
                    class="card-action-btn card-action-view"
                    (click)="viewReason(item)"
                    [testId]="'inbound-reason-mobile-link-button-' + item.id"
                  >
                    <i nz-icon nzType="link"></i>
                    {{ 'servicenumber.inbound-reason.action.copy-link' | i18n }}
                  </button>
                  <button
                    nz-button
                    nzType="default"
                    type="button"
                    class="card-action-btn card-action-edit"
                    (click)="editReason(item)"
                    [testId]="'inbound-reason-mobile-edit-button-' + item.id"
                  >
                    <i nz-icon nzType="edit"></i>
                    {{ 'common.edit' | i18n }}
                  </button>
                  <button
                    nz-button
                    nzType="default"
                    type="button"
                    class="card-action-btn"
                    [class.card-action-warning]="normalizeStatus(item?.status) === 'Enable'"
                    [class.card-action-success]="normalizeStatus(item?.status) !== 'Enable'"
                    (click)="toggleStatus(item)"
                    [testId]="'inbound-reason-mobile-toggle-button-' + item.id"
                  >
                    <i nz-icon [nzType]="normalizeStatus(item?.status) === 'Enable' ? 'pause' : 'caret-right'"></i>
                    {{
                      (normalizeStatus(item?.status) === 'Enable'
                        ? 'servicenumber.inbound-reason.action.disable'
                        : 'servicenumber.inbound-reason.action.enable'
                      ) | i18n
                    }}
                  </button>
                  <button
                    nz-button
                    nzType="default"
                    nzDanger
                    type="button"
                    class="card-action-btn card-action-danger"
                    (click)="deleteReason(item)"
                    [testId]="'inbound-reason-mobile-delete-button-' + item.id"
                  >
                    <i nz-icon nzType="delete"></i>
                    {{ 'common.delete' | i18n }}
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="hasMoreMobile" #mobileLoadMoreAnchor class="mobile-load-more-anchor" aria-hidden="true"></div>
            <div class="mobile-load-more" *ngIf="isLoadingMore">{{ 'common.loading' | i18n }}</div>
          </ng-container>

          <ng-template #mobileEmpty>
            <nz-empty />
          </ng-template>
        </nz-spin>
      </div>

      <div class="pagination-section" *ngIf="!isMobileView && total > 0" [testId]="'inbound-reason-pagination-section'">
        <div class="pagination-info" [testId]="'inbound-reason-pagination-info'">{{ 'common.total-records' | i18n: { total: total } }}</div>
        <div class="pagination-controls">
          <nz-pagination
            nzSize="small"
            [nzShowQuickJumper]="false"
            [nzPageIndex]="pageIndex"
            [nzTotal]="total"
            [nzPageSize]="pageSize"
            [nzShowSizeChanger]="false"
            [nzPageSizeOptions]="[10, 20, 50, 100]"
            (nzPageIndexChange)="nzPageIndexChange($event)"
            (nzPageSizeChange)="nzPageSizeChange($event)"
            [testId]="'inbound-reason-pagination'"
          />
        </div>
      </div>
    </div>

    <nz-drawer
      [nzVisible]="drawerVisible"
      nzPlacement="right"
      [nzWidth]="isMobileView ? '100%' : 440"
      [nzClosable]="false"
      [nzMaskClosable]="true"
      [nzKeyboard]="true"
      [nzTitle]="drawerTitle"
      (nzOnClose)="closeDrawer()"
      [testId]="'inbound-reason-detail-drawer'"
    >
      <ng-template #drawerTitle>
        <div class="drawer-header-block">
          <div class="drawer-title-bar">
            <div class="drawer-title">
              <div class="drawer-icon">
                <span class="type-emoji">{{ getIconForType(drawerReason?.type || drawerReason?.sourceType || '') }}</span>
              </div>
              <div class="drawer-title-content">
                <div class="title-text">{{ drawerReason?.title || '-' }}</div>
                <span class="status-pill" [ngClass]="getStatusPillClass(drawerReason)">
                  {{ getStatusI18nKey(drawerReason) | i18n }}
                </span>
              </div>
            </div>
            <i nz-icon nzType="close" class="drawer-close" (click)="closeDrawer()"></i>
          </div>
          <div class="drawer-status-row drawer-status-card">
            <div class="drawer-status-left">
              <div class="drawer-status-title">{{ 'servicenumber.inbound-reason.drawer.status.title' | i18n }}</div>
              <div class="drawer-status-desc">{{ 'servicenumber.inbound-reason.drawer.status.desc.enable' | i18n }}</div>
            </div>
            <div class="drawer-status-right">
              <nz-switch
                [ngModel]="normalizeStatus(drawerReason?.status) === 'Enable'"
                (ngModelChange)="toggleStatus(drawerReason)"
                [nzDisabled]="!drawerReason?.id"
                testId="inbound-reason-drawer-status-switch"
              />
            </div>
          </div>
        </div>
      </ng-template>
      <ng-container *nzDrawerContent>
        <nz-spin [nzSpinning]="drawerLoading">
          <div class="detail-drawer">
            <div class="drawer-header">
              <div class="section-title">{{ 'servicenumber.inbound-reason.drawer.overview.title' | i18n }}</div>
              <div class="overview-grid">
                <div class="overview-item">
                  <div class="overview-value">{{ formatNumber(getOverviewTotal(drawerReason)) }}</div>
                  <div class="overview-label">{{ 'servicenumber.inbound-reason.drawer.overview.total' | i18n }}</div>
                </div>
                <div class="overview-item">
                  <div class="overview-value">{{ formatNumber(getOverviewHuman(drawerReason)) }}</div>
                  <div class="overview-label">{{ 'servicenumber.inbound-reason.drawer.overview.human' | i18n }}</div>
                </div>
                <div class="overview-item">
                  <div class="overview-value">{{ formatRate(getOverviewConversion(drawerReason)) }}</div>
                  <div class="overview-label">{{ 'servicenumber.inbound-reason.drawer.overview.conversion' | i18n }}</div>
                </div>
              </div>
              <div class="overview-tip">
                <i nz-icon nzType="info-circle" class="overview-tip-icon"></i>
                <div class="overview-tip-text">
                  <span class="overview-tip-strong">{{ 'servicenumber.inbound-reason.drawer.overview.total' | i18n }}</span
                  >：{{ 'servicenumber.inbound-reason.drawer.overview.tip.total' | i18n }}
                  <span class="overview-tip-strong">{{ 'servicenumber.inbound-reason.drawer.overview.human' | i18n }}</span
                  >：{{ 'servicenumber.inbound-reason.drawer.overview.tip.human' | i18n }}
                  <span class="overview-tip-strong">{{ 'servicenumber.inbound-reason.drawer.overview.conversion' | i18n }}</span
                  >：{{ 'servicenumber.inbound-reason.drawer.overview.tip.conversion' | i18n }}
                </div>
              </div>
            </div>

            <div class="drawer-divider"></div>

            <div class="drawer-section">
              <div class="section-title">{{ 'servicenumber.inbound-reason.drawer.basic.title' | i18n }}</div>
              <div class="info-row">
                <div class="info-label">{{ 'servicenumber.inbound-reason.drawer.basic.source-type' | i18n }}</div>
                <div class="info-value">{{ getTypeLabel(drawerReason) }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">{{ 'servicenumber.inbound-reason.drawer.basic.reason' | i18n }}</div>
                <div class="info-value">{{ drawerReason?.title || '-' }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">{{ 'servicenumber.inbound-reason.drawer.basic.business-id' | i18n }}</div>
                <div class="info-value">{{ drawerReason?.businessId || '-' }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">{{ 'servicenumber.inbound-reason.drawer.basic.validity' | i18n }}</div>
                <div class="info-value">{{ drawerReason ? getValidityLabel(drawerReason) : '-' }}</div>
              </div>
              <div class="info-row" [testId]="'inbound-reason-drawer-regex-row'">
                <div class="info-label">{{ 'servicenumber.inbound-reason.drawer.basic.regex' | i18n }}</div>
                <div class="info-value">
                  <ng-container *ngIf="drawerReason?.regexEnabled && drawerReason?.regexRules?.length; else noRegex">
                    <div class="drawer-regex-list" [testId]="'inbound-reason-drawer-regex-list'">
                      <div
                        *ngFor="let rule of drawerReason?.regexRules; let i = index"
                        class="drawer-regex-item"
                        [testId]="'inbound-reason-drawer-regex-rule-' + i"
                      >
                        <code class="drawer-regex-code">{{ rule }}</code>
                        <i
                          nz-icon
                          nzType="copy"
                          class="drawer-regex-copy-icon"
                          nz-tooltip
                          [nzTooltipTitle]="'servicenumber.inbound-reason.drawer.regex.copy-rule' | i18n"
                          (click)="copyRegexRule(rule, $event)"
                          [testId]="'inbound-reason-drawer-regex-copy-btn-' + i"
                        ></i>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #noRegex><span [testId]="'inbound-reason-drawer-regex-empty'">-</span></ng-template>
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">{{ 'servicenumber.inbound-reason.drawer.basic.created-at' | i18n }}</div>
                <div class="info-value">
                  {{ formatDateTime(getCreatedAt(drawerReason)) }}
                </div>
              </div>
              <div class="info-row">
                <div class="info-label">{{ 'servicenumber.inbound-reason.drawer.basic.updated-at' | i18n }}</div>
                <div class="info-value">
                  {{ formatDateTime(getUpdatedAt(drawerReason)) }}
                </div>
              </div>
            </div>

            <div class="drawer-divider"></div>

            <div class="drawer-action-card">
              <div class="drawer-action-primary">
                <button
                  nz-button
                  nzType="primary"
                  nzBlock
                  (click)="generateLinkFromDrawer()"
                  [disabled]="!drawerReason?.id"
                  testId="inbound-reason-drawer-copy-link-button"
                >
                  <i nz-icon nzType="link"></i>
                  {{ 'servicenumber.inbound-reason.action.copy-link' | i18n }}
                </button>
              </div>
              <div class="drawer-action-secondary">
                <button
                  nz-button
                  nzType="default"
                  nzBlock
                  (click)="editReason(drawerReason)"
                  [disabled]="!drawerReason?.id"
                  testId="inbound-reason-drawer-edit-button"
                >
                  <i nz-icon nzType="edit"></i>
                  {{ 'common.edit' | i18n }}
                </button>
                <button
                  nz-button
                  nzType="default"
                  nzDanger
                  nzBlock
                  (click)="deleteReason(drawerReason)"
                  [disabled]="!drawerReason?.id"
                  testId="inbound-reason-drawer-delete-button"
                >
                  <i nz-icon nzType="delete"></i>
                  {{ 'common.delete' | i18n }}
                </button>
              </div>
            </div>
          </div>
        </nz-spin>
      </ng-container>
    </nz-drawer>

    <nz-modal
      [(nzVisible)]="linkModalVisible"
      [nzFooter]="null"
      [nzWidth]="isMobileView ? 'calc(100vw - 24px)' : 640"
      nzClassName="inbound-reason-link-modal"
      (nzOnCancel)="closeLinkModal()"
      [nzTitle]="'servicenumber.inbound-reason.link.modal.title' | i18n"
      [testId]="'inbound-reason-link-modal'"
    >
      <ng-container *nzModalContent>
        <div class="link-modal-container">
          <div class="reason-info-card" [testId]="'inbound-reason-info-card'">
            <div class="reason-icon">
              <span class="reason-emoji">{{ getIconForType(currentReasonType || '') }}</span>
            </div>
            <div class="reason-text">
              <div class="reason-title">{{ currentReasonName }}</div>
              <div class="reason-desc">
                {{ currentReasonDescription ? currentReasonDescription : ('servicenumber.inbound-reason.empty.description' | i18n) }}
              </div>
            </div>
          </div>

          <div class="link-section" *ngIf="!isPersonTenant() && !embedded" [testId]="'inbound-reason-servicenumber-section'">
            <div class="section-title">
              <span class="section-icon">👤</span>
              <span class="section-label">{{ 'servicenumber.inbound-reason.link.service-number.label' | i18n }}</span>
            </div>
            <nz-select
              nzShowSearch
              nzAllowClear
              [nzLoading]="serviceNumberLoading"
              [(ngModel)]="serviceNumberId"
              (ngModelChange)="onLinkServiceNumberChange()"
              (nzOnSearch)="onServiceNumberSearch($event)"
              (nzOpenChange)="onServiceNumberDropdownOpenChange($event)"
              (nzScrollToBottom)="onServiceNumberScrollToBottom()"
              [nzPlaceHolder]="'servicenumber.inbound-reason.link.service-number.placeholder' | i18n"
              [nzServerSearch]="true"
              [nzDropdownClassName]="'inbound-reason-service-number-dropdown'"
              class="link-service-number-select"
              [testId]="'inbound-reason-servicenumber-select'"
            >
              <nz-option
                *ngFor="let option of serviceNumberOptions"
                [nzValue]="option.id"
                [nzLabel]="option.name"
                [testId]="'inbound-reason-servicenumber-option-' + option.id"
              />
              <nz-option
                *ngIf="serviceNumberLoadingMore"
                nzCustomContent
                [nzDisabled]="true"
                [nzValue]="'__service-number-loading__'"
                [nzLabel]="'common.loading' | i18n"
              >
                <div class="service-number-loading-option">
                  <span class="ios-loading-dots" aria-hidden="true">
                    <span></span>
                    <span></span>
                    <span></span>
                  </span>
                  <span class="loading-text">{{ 'common.loading' | i18n }}</span>
                </div>
              </nz-option>
            </nz-select>
          </div>

          <div class="link-section" [testId]="'inbound-reason-link-section'">
            <div class="section-title">
              <span class="section-icon">🌐</span>
              <span class="section-label">{{ 'servicenumber.inbound-reason.link.section.title' | i18n }}</span>
            </div>
            <div class="link-mode-block">
              <div class="link-mode-label">{{ 'servicenumber.webchat.share.loginMode.label' | i18n }}</div>
              <nz-radio-group
                class="link-mode-group"
                [(ngModel)]="reasonLoginMode"
                (ngModelChange)="onReasonLoginModeChange($event)"
                testId="inbound-reason-link-mode-radio"
              >
                <label nz-radio nzValue="anonymous">{{ 'servicenumber.webchat.share.loginMode.anonymous' | i18n }}</label>
                <label nz-radio nzValue="mobile">{{ 'servicenumber.webchat.share.loginMode.mobile' | i18n }}</label>
              </nz-radio-group>
            </div>
            <div class="link-input-row">
              <input
                nz-input
                [value]="currentReasonLink"
                readonly
                [placeholder]="'servicenumber.inbound-reason.search.placeholder' | i18n"
                [testId]="'inbound-reason-link-input'"
              />
              <button
                nz-button
                nzType="default"
                class="copy-button"
                (click)="copyCurrentLink()"
                [disabled]="!currentReasonLink"
                [testId]="'inbound-reason-link-copy-button'"
              >
                <i nz-icon nzType="copy"></i>
                {{ 'servicenumber.inbound-reason.link.copy' | i18n }}
              </button>
            </div>
          </div>

          <div class="qr-section" [testId]="'inbound-reason-qr-section'">
            <div class="section-title">
              <span class="section-icon">📷</span>
              <span class="section-label">{{ 'servicenumber.inbound-reason.qr.section.title' | i18n }}</span>
            </div>
            <div class="qr-content">
              <div class="qr-preview" [testId]="'inbound-reason-qr-preview'">
                <div class="qr-box">
                  <ng-container *ngIf="qrCodeDataUrl; else qrEmpty">
                    <img [src]="qrCodeDataUrl" alt="QR code" />
                  </ng-container>
                  <ng-template #qrEmpty>
                    <div class="qr-empty" [testId]="'inbound-reason-qr-empty'">
                      <span>{{ currentReasonName || ('servicenumber.inbound-reason.title' | i18n) }}</span>
                    </div>
                  </ng-template>
                </div>
              </div>
              <div class="qr-right">
                <div class="qr-size-row">
                  <span class="label">{{ 'servicenumber.inbound-reason.qr.size.label' | i18n }}</span>
                  <nz-radio-group
                    class="size-group"
                    [(ngModel)]="selectedQrSize"
                    (ngModelChange)="onQrSizeChange($event)"
                    testId="inbound-reason-qr-size-radio"
                  >
                    <label nz-radio [nzValue]="256">256px</label>
                    <label nz-radio [nzValue]="512">512px</label>
                    <label nz-radio [nzValue]="1024">1024px</label>
                  </nz-radio-group>
                </div>
                <div class="qr-actions">
                  <button
                    nz-button
                    nzType="default"
                    (click)="downloadQr('png')"
                    [disabled]="!currentReasonLink"
                    [testId]="'inbound-reason-qr-download-png'"
                  >
                    <i nz-icon nzType="download"></i>
                    {{ 'servicenumber.inbound-reason.qr.download.png' | i18n }}
                  </button>
                  <button
                    nz-button
                    nzType="default"
                    (click)="downloadQr('svg')"
                    [disabled]="!currentReasonLink"
                    [testId]="'inbound-reason-qr-download-svg'"
                  >
                    <i nz-icon nzType="download"></i>
                    {{ 'servicenumber.inbound-reason.qr.download.svg' | i18n }}
                  </button>
                </div>
                <div class="qr-tip">
                  <i nz-icon nzType="info-circle" nzTheme="outline" class="qr-tip-icon"></i>
                  <span class="qr-tip-text">{{ 'servicenumber.inbound-reason.qr.tip' | i18n }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </nz-modal>
    <ng-template #deleteConfirmTitleTpl>
      <span style="display: inline-flex; gap: 12px; align-items: center">
        <i nz-icon nzType="exclamation-circle" style="color: #ff4d4f; font-size: 22px"></i>
        <span>{{ deleteConfirmTitle }}</span>
      </span>
    </ng-template>
    <ng-template #deleteConfirmTpl>
      <div>{{ deleteConfirmDesc }}</div>
      <br />
      <div>{{ deleteConfirmItem1 }}</div>
      <div>{{ deleteConfirmItem2 }}</div>
      <div style="color: #ff4d4f">{{ deleteConfirmItem3 }}</div>
    </ng-template>
  </div>
</div>
